import React from "react";
import { Link, useParams } from "react-router-dom";
import { parseBookingRef } from "../../../utils/bookingRef";
import Bookings from "../Bookings";
import BookingStepper from "./BookingStepper";

// What /vendor_bookings and /vendor_bookings/:group_id render for every non-clinic industry.
// (The clinic books through its own slider - NewAppointment.jsx - and never reaches this.)
//
// The page this replaced (../Bookings.jsx) is kept, unused, as a fallback while the stepper
// settles in: add ?legacy=1 to the address, or set localStorage "useLegacyBookingForm" = "1",
// to open it instead. Once the stepper is signed off, delete ../Bookings.jsx and this switch.
export const wantsLegacyForm = () => {
  try {
    return (
      new URLSearchParams(window.location.search).get("legacy") === "1" ||
      localStorage.getItem("useLegacyBookingForm") === "1"
    );
  } catch (e) {
    return false;
  }
};

// A /vendor_bookings/<ref> address whose ref carries no readable group id (see
// utils/bookingRef.js) must not fall through to the page: with no group id it
// would open as a blank NEW booking.
const BookingNotFound = ({ bookingRef }) => (
  <div className="container py-5 text-center" role="alert">
    <h4>Booking not found</h4>
    <p className="text-muted">
      "{bookingRef}" isn't a booking reference this page can open.
    </p>
    <Link to="/dashboard" className="btn btn-primary">Back to dashboard</Link>
  </div>
);

export default function BookingsRoute() {
  const { group_id } = useParams();
  if (parseBookingRef(group_id).invalid) return <BookingNotFound bookingRef={group_id} />;
  return wantsLegacyForm() ? <Bookings /> : <BookingStepper />;
}
